export const STATIONS = [
  {
    code: "NPP",
    type: "sorting",
    tracks: 6,
    name: {
      en: "Northern Prep Plant",
      uk: "Північна збагачувальна фабрика",
      ru: "Северная обогатительная фабрика",
      bg: "Северна обогатителна фабрика",
    },
  },
  {
    code: "DEP",
    type: "loading",
    tracks: 3,
    name: {
      en: "Coal Depot",
      uk: "Вугільний склад",
      ru: "Угольный склад",
      bg: "Въглищен склад",
    },
  },
  {
    code: "M1",
    type: "loading",
    tracks: 3,
    name: {
      en: "Mine No. 1",
      uk: "Шахта № 1",
      ru: "Шахта № 1",
      bg: "Мина № 1",
    },
  },
  {
    code: "M3",
    type: "loading",
    tracks: 2,
    name: {
      en: "Mine No. 3",
      uk: "Шахта № 3",
      ru: "Шахта № 3",
      bg: "Мина № 3",
    },
  },
  {
    code: "WM",
    type: "loading",
    tracks: 2,
    name: {
      en: "West Mine",
      uk: "Західна шахта",
      ru: "Западная шахта",
      bg: "Западна мина",
    },
  },
];
